<div class="row">
  <div class="col-md-6">
    <h4 class="pull-left">Available Providers</h4>
    <button
      class="btn btn-default pull-right"
      [disabled]="availableSelection.length === 0"
      (click)="select()"
    >
      <i class="fa fa-arrow-right"></i> Add To Selected
    </button>
  </div>

  <div class="col-md-6">
    <h4 class="pull-left">Selected Providers</h4>
    <button
      class="btn btn-default pull-right"
      [disabled]="selectedSelection.length === 0"
      (click)="remove()"
    >
      <i class="fa fa-arrow-left"></i> Remove from Selected
    </button>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <app-grid-wrapper #available (cellDoubleClicked)="select()"></app-grid-wrapper>
  </div>

  <div class="col-md-6">
    <app-grid-wrapper #selected (cellDoubleClicked)="remove()"></app-grid-wrapper>
  </div>
</div>
